<template>
  <div class="Atendimento">
    <div class="row Atendimento_header">
      <div class="col-2 Atendimento_header--back align-items-center justify-content-center d-inline-flex"
           @click="goHome()">
        <icon-svg icon="arrowLeft"
                  class="icon--md Atendimento_header--back--icon" />
        Voltar
      </div>

      <div class="col">
        <div @click="goHome()">
          <icon-svg icon="sofiaLogoWhite"
                    class="Atendimento_header--logo" />
        </div>
      </div>
    </div>

    <div>
      <div class="content p-0 pt-3">
        <article>
          <h1 class="Atendimento_title">
            Fale Conosco
          </h1>
          <div class="Atendimento_text pt-1 pb-3">
            Você pode entrar em contato com nosso suporte preenchendo o formulário abaixo ou pelo chat localizado a 
            direita da página ou através do nosso telefone: <b>(11) 4780-6361</b>.
          </div>
          <div class="esconder-h1" />
        </article>         
        <article>
          <embed :src="urlForm"
                 class="Atendimento--embed">
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Atendimento",
    data () {
      return {
        urlForm: process.env.VUE_APP_FORM_AJUDA_URL
      }
    },
    mounted () {
      loader({ active: true })
      document.getElementById("md-app-widget").style.visibility = "visible"

      // aguandando carregamento de conteudo de terceiros
      const myEmbed = document.querySelector('.Atendimento--embed')
      myEmbed.addEventListener("load", function () {
        loader({ active: false })
      })
    },
    destroyed () {
      document.getElementById("md-app-widget").style.visibility = "hidden"
    },
    methods: {
      goHome () {
        // movendo para login, caso esteja logado redirecionara para home
        // usando "window.location.href" para fugir do $router e forcar o carregamento completo da pagina
        window.location.href = '/'
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../scss/_utilities/_exports';

  .esconder-h1{
    width: 100%;
    height: 36px;
    background: white;
    position: absolute;
    margin-top: -10px;
  }
  .Atendimento {
    &_header {
      height: 80px !important;
      width: 100% !important;
      background-color: #074f7f !important;
      top: 0;
      margin: 0;
      position: fixed !important;
      z-index: 1000;

      &--back{
        border: 2px solid #074f7f;
        background-color: #ffffff;
        color: #074f7f;
        cursor: pointer;

        &--icon {
          fill: #074f7f;
        }
      }

      &--logo {
        cursor: pointer;
        margin-top: 15px;
        height: 50px;
        width: 150px;
      }
    }

    &_title {
     margin-left: 150px;
     font-weight: 500;
     font-size: 24px;
    }

    &_text {
    margin-left: 150px;
    margin-right: 200px;
    font-size: 16px;
    font-weight: 400;
    }

    & content {
      border-color: 2px solid black;
      box-shadow: 0 0 pxToRem(10) pxToRem(.4) lightgrey !important;
      margin: pxToRem(100) auto pxToRem(40);
    }

    &--embed{
      width: 100%;
      height: 51rem;
      margin-top: -20px;
    }
  }
</style>
